import { ImMap, ImSet } from "@/twapp/react/tromanImmutable";
import { IContainer, IEntry, isFile } from "../model/fileModel";
import { UserData } from "@/common/account/UserData";
import { getFilenameAndExtension } from "../model/fileValidation";
import { TromanError } from "@/common/TromanError";
import _ from "lodash";

export interface IEditForm {
    name: string;
    showPolitiker: boolean;
    showPublik: boolean;
}

export interface IPreparedEdit {
    existingNamesLC: ImSet<string>;
    container: IContainer,
    entry?: IEntry;
    user?: UserData;
    isFile: boolean;
    extension: string;
    initial: IEditForm;
}

export function prepareEdit(container: IContainer, entry: IEntry, users: ImMap<string, UserData>): IPreparedEdit {
    const allEntries = _.concat<IEntry>(container.files, container.folders).filter(x => x !== entry).map(x => x.name.toLowerCase());

    if (isFile(entry)) {
        const nameParts = getFilenameAndExtension(entry.name);
        if (!nameParts) throw new TromanError('parse_filename_extension');

        return {
            entry,
            container,
            isFile: true,
            user: users.get(entry.source.CreatedById),
            extension: nameParts.extension,
            existingNamesLC: ImSet(allEntries),
            initial: {
                name: nameParts.filename,
                showPolitiker: entry.showPolitiker,
                showPublik: entry.showPublik,
            }
        };
    } else {
        return {
            entry,
            container: container,
            isFile: false,
            user: users.get(entry.source.CreatedById),
            extension: '',
            existingNamesLC: ImSet(allEntries),
            initial: {
                name: entry.name,
                showPolitiker: false,
                showPublik: false,
            }
        };
    }
}

export function prepareCreateFolder(container: IContainer): IPreparedEdit {
    const allEntries = _.concat<IEntry>(container.files, container.folders).map(x => x.name.toLowerCase());
    return {
        isFile: false,
        container: container,
        extension: '',
        existingNamesLC: ImSet(allEntries),
        initial: {
            name: '',
            showPolitiker: false,
            showPublik: false,
        }
    };
}
